import { type Currency } from '@webapp/core/entities/external/Currency'
import { type ExpenseTypeEnum } from '../enums/ExpenseTypeEnum'

export interface ExpenseDraftItemAccount {
  id: number
  accountCode: {
    id: number
    code: string
    description: string
  }
}

export interface ExpenseDraftItemCreditCard {
  id: number
  name: string
  number: string
  type: Nullable<number>
}

export interface ExpenseDraftItemConstructor {
  id: number
  merchant: string
  accountId: number
  reimbursable: boolean
  expenseType: ExpenseTypeEnum
  paymentType: number
  amount: number
  taxPercentage: string
  taxName: string
  currency: Currency
  transactionDate: string
  attachment: string
  notes: string
  expenseTypeFields: Record<string, unknown> | null
  taxAmount: number
  taxId: Nullable<number>
  creditCardId: Nullable<number>
  account: ExpenseDraftItemAccount | null
  creditCard: ExpenseDraftItemCreditCard | null
}

export class ExpenseDraftItem {
  readonly id: number
  readonly merchant: string
  readonly accountId: number
  readonly reimbursable: boolean
  readonly expenseType: ExpenseTypeEnum
  readonly paymentType: number
  readonly amount: number
  readonly taxPercentage: string
  readonly taxName: string
  readonly currency: Currency
  readonly transactionDate: string
  readonly attachment: string
  readonly notes: string
  readonly expenseTypeFields: Record<string, unknown> | null
  readonly taxAmount: number
  readonly taxId: Nullable<number>
  readonly creditCardId: Nullable<number>
  readonly account: ExpenseDraftItemAccount | null
  readonly creditCard: ExpenseDraftItemCreditCard | null

  constructor(data: ExpenseDraftItemConstructor) {
    this.id = data.id
    this.merchant = data.merchant
    this.accountId = data.accountId
    this.reimbursable = data.reimbursable
    this.expenseType = data.expenseType
    this.paymentType = data.paymentType
    this.amount = data.amount
    this.taxPercentage = data.taxPercentage
    this.taxName = data.taxName
    this.currency = data.currency
    this.transactionDate = data.transactionDate
    this.attachment = data.attachment
    this.notes = data.notes
    this.expenseTypeFields = data.expenseTypeFields ?? null
    this.taxAmount = data.taxAmount
    this.taxId = data.taxId ?? null
    this.creditCardId = data.creditCardId ?? null
    this.account = data.account ?? null
    this.creditCard = data.creditCard ?? null
  }
}
